import { useGetPricingsQuery } from ".";

export const useGetPricingById = (id?: string) => {
  const { data } = useGetPricingsQuery();

  return data?.resources.find(p => p.pricingId === id);
};
